import API from "@utils/plugins/API";

const IssuingOfficeService = {
  all: (params) => {
    return API.get("issuing-offices", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("issuing-offices", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`issuing-offices/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`issuing-offices/${id}`);
  },
  destroy: (id) => {
    return API.delete(`issuing-offices/${id}`);
  },
};

export default IssuingOfficeService;
